import { useAuth0 } from "@auth0/auth0-react";
import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useTheme } from "../ThemeContext/ThemeContext.js";
import {
  Container,
  IconButton,
  Toolbar,
  styled,
  Tooltip,
} from "@mui/material";
import { goodTime } from "../components/util";
import InviteDialogNew from "./invite-dialog.js";
import OrgUserMenu from "./orgUserMenu";
import * as api from "../api/api";
import CloseIcon from "@mui/icons-material/Close";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Styled from "@emotion/styled";
import EditIcon from "@mui/icons-material/Edit";
// import { DashboardTitleTypography } from "../dashboard/dashboard";
import DataGrid from "../components/DataGrid/DataGrid.tsx";
import {
  H4HeadlineLarge,
  H6HeadlineSmall,
  BodyLarge,
  BodyMedium,
  LabelMedium,
  LabelLarge,
  H9TitleSmall,
} from "../components/StyledComponents/Typography/Typography.tsx";
import { format, parseISO } from "date-fns";
import WhitelistDomainsDialog from "./whitelist_domains_dialog.js";
import { SecondaryButton } from "../components/StyledComponents/Buttons/AuradineButtons.js";
import { UserProfileDialog } from "./UserProfile.js";
import {
  Query,
  QueryClient,
  QueryClientProvider,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import PermissionsDialog from "./sitePermissionsDialog.js";
import { GridNoRowsOverlay } from "@mui/x-data-grid-pro";
import PageWrapper from "../components/PageWrapper/PageWrapper.js";
import AuradineErrorState from "../components/StyledComponents/EmptyStates/AuradineErrorState.tsx";  

const HeaderContainer = React.memo((props) => {
  return (
    <Box
      className={"header-container"}
      display={"flex"}
      justifyContent="flex-start"
      flexDirection="column"
      gap={4}
      marginBottom={"1.5rem"}
    >
      <Box
        className={"title-box"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-between"}
        gap={3.5}
      >
        <H6HeadlineSmall>Administrators</H6HeadlineSmall>
        <BodyLarge>
          View and manage the list of administrators. You
          can invite new members, and adjust roles for those
          who have access to the FluxVision management
          console.
        </BodyLarge>
      </Box>
    </Box>
  );
});

const getColumns = (colors) => [
  {
    field: "name",
    headerName: "User name",
    minWidth: 150,
    flex: 1,
  },
  {
    field: "email",
    headerName: "Email",
    minWidth: 150,
    flex: 1,
  },
  {
    field: "role",
    headerName: "Role",
    minWidth: 150,
    flex: 1,
    renderCell: (params) =>
      params.value === "user" ? "readonly" : params.value,
  },
  {
    field: "authorizedSites",
    headerName: "Authorized Sites",
    minWidth: 200,
    flex: 1.5,
    sortable: false,
    renderCell: (params) => {
      const user = params.row;

      // Scenario 1: User is a superadmin
      if (user.role === "superadmin") {
        return (
          <BodyLarge
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
            }}
          >
            All Sites
          </BodyLarge>
        );
      }

      // Scenario 2: User is a non-superadmin with no permissions object
      if (!user.permissions) {
        return (
          <BodyLarge
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
            }}
          >
            All Sites
          </BodyLarge>
        );
      }

      // Scenario 3: User is a non-superadmin with permissions object containing sites
      if (user.permissions.sites && Array.isArray(user.permissions.sites) && user.permissions.sites.length > 0) {
        const sites = user.permissions.sites;

        if (sites.length <= 3) {
          return (
            <BodyLarge
              style={{
                whiteSpace: "normal",
                wordWrap: "break-word",
              }}
            >
              {sites.join(", ")}
            </BodyLarge>
          );
        }

        return (
          <Tooltip
            title={sites.join(", ")}
            arrow
            placement="top"
          >
            <BodyLarge
              style={{
                whiteSpace: "normal",
                wordWrap: "break-word",
                cursor: "pointer",
              }}
            >
              {sites.slice(0, 2).join(", ")} <span style={{ color: colors?.primary?.main }}>+{sites.length - 2} more</span>
            </BodyLarge>
          </Tooltip>
        );
      }

      // Scenario 4: User is a non-superadmin with permissions object but no sites
      return (
        <BodyLarge
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
          }}
        >
          No Authorized Sites
        </BodyLarge>
      );
    },
  },
  {
    field: "invitedAt",
    headerName: "Invited",
    flex: 1,
    minWidth: 150,
    valueGetter: (params) => {
      return params
        ? format(parseISO(params), "MM/dd/yyyy HH:mm:ss ")
        : null;
    },
  },
  {
    field: "createdAt",
    headerName: "Joined",
    flex: 1,
    minWidth: 150,
    valueGetter: (params) =>
      params
        ? format(parseISO(params), "MM/dd/yyyy HH:mm:ss ")
        : null,
  },
];

var UserA = {};
var OrgA = {};

const OrganizationPage = () => {
  const [edit, setEdit] = useState(false);
  const { colors } = useTheme();
  const [state, setState] = useState(false);
  const [submitMsg, setSubmitMsg] = useState("");
  const [successModalOpen, setSuccessModalOpen] =
    useState(false);
  const [pageSize, setPageSize] = useState(25);
  const [selectedRow, setSelectedRow] = useState([]);
  const [siteDataEditMode, setSiteDataEditMode] =
    useState(false);
  const [userRoleEditMode, setUserRoleEditMode] =
    useState(false);

  const [org, setOrg] = useState({
    org_id: "",
    name: "",
    member: [],
    owner: "",
  });

  const [
    sitePermissionsDialogOpen,
    setSitePermissionsDialogOpen,
  ] = useState(false);

  const [userProfileOpen, setUserProfileOpen] =
    useState(false);

  const { isAuthenticated, getAccessTokenSilently } =
    useAuth0();

  const handleUserProfileDialogOpen = (params) => {
    setSelectedRow(params && params.row ? params.row : {});
    setUserProfileOpen((prev) => !prev);
  };

  const handleOpenSitePermissionsDialog = (params) => {
    setSitePermissionsDialogOpen((prev) => !prev);
  };
  useEffect(() => {
    const fn = async () => {
      const token = await getAccessTokenSilently();
      await api.GetUser(token, (data) => {
        if (data.status === "error") {
          if (data.errorCode === 1007) {
            setSubmitMsg("nouser");
            setSuccessModalOpen(true);
          } else {
            setSubmitMsg("fetchfailed");
            setSuccessModalOpen(true);
          }
        } else {
          setSubmitMsg("ok");
          setSuccessModalOpen(true);

          UserA = data;
        }
      });
      api.GetOrg(token, (data) => {
        setOrg(data);
        OrgA = data;
      });
    };
    fn();
  }, [edit, state]);

  const refetchOrgData = async () => {
    const token = await getAccessTokenSilently();
    await api.GetUser(token, (data) => {
      if (data.status === "error") {
        if (data.errorCode === 1007) {
          setSubmitMsg("nouser");
          setSuccessModalOpen(true);
        } else {
          setSubmitMsg("fetchfailed");
          setSuccessModalOpen(true);
        }
      } else {
        setSubmitMsg("ok");
        setSuccessModalOpen(true);

        UserA = data;
      }
    });
    api.GetOrg(token, (data) => {
      setOrg(data);
      OrgA = data;
    });
  };

  const handleInputChange = (event) => {
    const target = event.target;
    const value =
      target.type === "checkbox"
        ? target.checked
        : target.value;
    const tname = target.name;

    setOrg((prevState) => ({
      ...prevState,
      [tname]: value,
    }));
  };

  const submitHandler = async (event) => {
    event.preventDefault();

    const fn = async () => {
      const token = await getAccessTokenSilently();
      const data = await api.PostOrg(token, {
        name: org.name,
      });
      if (
        data.hasOwnProperty("errorCode") &&
        data.errorCode === 1009
      ) {
        setSubmitMsg("unauth");
        setSuccessModalOpen(true);
      } else if (data.status === "error") {
        setSubmitMsg("error");
        setSuccessModalOpen(true);
      } else {
        //validUser = 0
        setEdit(false);
      }
    };
    fn();
  };

  const [authToken, setAuthToken] = useState("");
  // Use the useAuth0 hook to get authentication status and token fetching function

  useEffect(() => {
    const fetchToken = async () => {
      try {
        if (!isAuthenticated) {
          setAuthToken("");
          console.warn(
            "User is not authenticated. Fetching token..."
          );
          return;
        }
        const token = await getAccessTokenSilently({
          cacheMode: "cache-only",
          ignoreCache: true,
        });
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
    const interval = setInterval(() => {
      fetchToken();
    }, 5 * 60 * 1000); // Refresh every 15 minutes

    return () => clearInterval(interval); // Cleanup on unmount
  }, [getAccessTokenSilently, isAuthenticated]);

  let membersData = [];

  const {
    data: userData,
    isLoading,
    isFetching,
    isError: isMembersDataError,
    isFetched,
    refetch,
  } = useQuery({
    queryKey: ["user"],
    queryFn: ({ queryKey }) =>
      api.GetUserUseQuery(authToken),
    enabled: !!authToken,
  });
  const orgId =
    isFetched && userData?.user?.org_id
      ? userData?.user?.org_id
      : "";
  const role =
    isFetched && userData?.user ? userData?.user?.role : "";
  const name =
    isFetched && userData?.user ? userData?.user?.name : "";
  console.log("role", userData);
  const email =
    isFetched && userData?.user
      ? userData?.user?.email
      : "";

  const {
    data: members,
    refetch: membersDataRefetch,
    isLoading: isMembersDataLoading,
    isFetching: isMembersDataFetching,
    isFetched: isMembersDataFetched,
  } = useQuery({
    queryKey: ["membersData", orgId], // Use only serializable values
    queryFn: () => api.GetOrgUseQuery(authToken, orgId), // Pass correct arguments
    enabled: !!authToken,
  });

  if (isMembersDataFetched && members) {
    membersData =
      isMembersDataFetched &&
      members?.org?.user &&
      members?.org?.user.length > 0
        ? members?.org?.user.map((user) => user)
        : [];
  }

  const { user: tableRows } = org;
  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  const CustomGridRowsOverlay = () => {
    if (isMembersDataLoading) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          sx={{
            backgroundColor: colors.background.muted, // Custom background color
            // Custom text color
            fontSize: "1.2rem",
            fontWeight: "bold",
          }}
        >
          Loading Data...
        </Box>
      );
    }
    if (
        membersData.length === 0 &&
      isFetched &&
      members &&
      members.pages &&
      Array.isArray(members.pages) &&
      members.pages.length > 0 &&
      members.pages[0].status === "ok"
    ) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          sx={{
            backgroundColor: colors.background.paper, // Custom background color
            color: colors.text.muted, // Custom text color
            fontSize: "1.2rem",
            fontWeight: "bold",
          }}
        >
          No data available
        </Box>
      );
    }
    if (
      isMembersDataError ||
      (isFetched &&
        members.pages &&
        Array.isArray(members.pages) &&
        members.pages.length > 0 &&
        members.pages[0].status.toLowerCase() === "error")
    ) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          sx={{
            backgroundColor: colors?.background?.paper, // Custom background color 
            color: colors?.text?.muted, // Custom text color
            fontSize: "1.2rem",
            fontWeight: "bold",
          }}
        >
          <AuradineErrorState
            message={
              members?.pages[0]?.msg ||
              "Oops!! Something went wrong!!"
            }
          />
        </Box>
      );
    }
  };

  const dataGridProps = {
    rows: Array.isArray(membersData) ? membersData : [],
    columns: getColumns(colors),
    pagination: true,
    pageSize,
    page: 0,
    paginationMode: "client",
    loading: isMembersDataLoading || isMembersDataFetching,
    slots: {
      noRowsOverlay: CustomGridRowsOverlay,
    },
    slotProps: {
      loadingOverlay: {
        variant: "linear-progress",
        noRowsVariant: "skeleton",
        sx: {
          backgroundColor: colors.background.paper,
        },
      },
    },
    rowCount: Array.isArray(tableRows)
      ? tableRows.length
      : 0,
    onPageSizeChange: handlePageSizeChange,
    rowsPerPageOptions: [25, 50, 100],
    getRowId: (row) => row.email,
    disableColumnMenu: true,
    disableColumnResize: true,
    checkboxSelection: false,
    disableSelectionOnClick: false,
    onRowClick: handleUserProfileDialogOpen,
    disableCellSelection: true,
  };

  return (
      <PageWrapper sx={{ gap: 6 }}>
      <Box
        className={"header-container"}
        display={"flex"}
        justifyContent="flex-start"
        flexDirection="column"
        gap={4}
        marginBottom={"1.5rem"}
      >
        <HeaderContainer />
        <Box
          display={"flex"}
          flexDirection={"row"}
          flexGrow={3}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={2}
          >
            <Box
              display="flex"
              flexDirection="row"
              gap={4}
              alignItems={"center"}
              justifyContent={"flex-start"}
            >
              <LabelMedium>
                Organization ID:
              </LabelMedium>
              <BodyLarge >
                {org?.org_id}
              </BodyLarge>
            </Box>
          </Box>
          <Box
            display={"flex"}
            flexDirection={"row"}
            flexGrow={3}
            alignItems={"center"}
            justifyContent={"flex-end"}
            gap={4}
          >
            <Box>
              <SecondaryButton colors={colors}
                disabled={role !== "superadmin"}
                onClick={handleOpenSitePermissionsDialog}
                endIcon={
                  <span className="material-symbols-outlined">
                    visibility_lock
                  </span>
                }
              >
                Permissions
              </SecondaryButton>
            </Box>
            <WhitelistDomainsDialog
              setState={setState}
              org={OrgA}
              role={role}
            />
            <InviteDialogNew
              setState={setState}
              org={OrgA}
              userRole={role}
              refetch={membersDataRefetch}
            />
            <PermissionsDialog
              open={sitePermissionsDialogOpen}
              handleClose={handleOpenSitePermissionsDialog}
              refetch={membersDataRefetch}
              orgId={orgId}
            />
            <UserProfileDialog
              open={userProfileOpen}
              handleClose={handleUserProfileDialogOpen}
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
              role={role}
              name={name}
              refetch={membersDataRefetch}
              email={email}
            />
          </Box>
        </Box>
      </Box>
      <Box
        className={"org-page-table"}
        display={"flex"}
        flexDirection={"row"}
        backgroundColor={colors.background.paper} 
        padding={"0.75rem 0.75rem  0.75rem 0.75rem"}
        borderRadius={"1rem"}
        sx={{
          transition: "width 0.3s ease-in-out", // Smooth transition for width
        }}
      >
        <DataGrid
          colors={colors}
          config={dataGridProps}
          height="calc(100vh - 18rem)"
        />
      </Box>
    </PageWrapper>
  );
};

const OrgPage = () => {
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <OrganizationPage />
    </QueryClientProvider>
  );
};

export default OrgPage;
